import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { TypeOperationModel } from '@app/src/views/StepOne/form';
import { OPERATION_ICON } from './constants';

export const hydrateData = (data: TypeOperationModel[]) =>
  data.map((item) => ({
      value: String(item.id),
      text: item.name,
      data: {...item, icon: OPERATION_ICON[item.alias]}
  })) as SelectItemModel[]
